import React from "react";

// Logo Cãomiar Dog Walker (dois cães formando um coração + wordmark).
// Fornecido pela cliente e usado como imagem única (já contém o wordmark).
export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_caomiar-rebrand/artifacts/h7dm5vpt_image.png";

/**
 * Logo
 * Renderiza o logotipo completo (símbolo + wordmark integrados).
 * - `height` controla o tamanho vertical em px (o width se ajusta pela imagem).
 * - `light` embrulha o logo em um pill creme para preservar o contraste
 *   quando exibido sobre fundos escuros (footer, panfleto verde, etc.).
 */
export const Logo = ({ height = 48, light = false, className = "" }) => {
  const inner = (
    <img
      src={LOGO_URL}
      alt="Cãomiar Dog Walker"
      style={{ height, width: "auto" }}
      className="object-contain select-none block"
      draggable="false"
    />
  );
  if (!light) {
    return (
      <div className={"inline-flex items-center " + className} data-testid="brand-logo">
        {inner}
      </div>
    );
  }
  return (
    <div
      className={"inline-flex items-center bg-brand-cream rounded-2xl px-3 py-2 " + className}
      data-testid="brand-logo"
    >
      {inner}
    </div>
  );
};

// Alias mantido por compatibilidade (usado nos panfletos e footer)
export const LogoMark = Logo;

export default Logo;
